import React from 'react';
import './AtelierHomeSection.css';

/**
 * CTA home → Atelier. Fondo negro (#000) como el footer.
 * Ubicación: entre EXPERIENCIAS REALES y ECOSISTEMA.
 */
const AtelierHomeSection = () => {
  const go = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <section className="atelier-home" id="atelier" aria-labelledby="atelier-home-title">
      <div className="atelier-home-inner">
        <span className="atelier-home-tag">SERVICIOS · ATELIER</span>
        <h2 className="atelier-home-title" id="atelier-home-title">
          ¿Te gustó esta página y el ecosistema?
        </h2>
        <p className="atelier-home-lead">
          Así trabajamos en Atelier: diseñamos, lanzamos y evolucionamos ecosistemas
          digitales para marcas que quieren crecer con método — no con improvisación.
        </p>
        <button
          type="button"
          className="atelier-home-cta"
          onClick={() => go('/servicios/product-studio')}
        >
          Conoce Atelier
        </button>
      </div>
    </section>
  );
};

export default AtelierHomeSection;
